// src/intersection.js

import { VehicleManager } from '../vehicleManager.js';
import * as charts from './intersection-charts.js';
import { refreshResults, updateFreightMode, updateFreightResult } from './intersection-results.js';

let v, v2; //VehicleManager instantiated in load page
let latestResults = null;

const catName = 'wa-intersection';

const clearanceCalcUri = '/api/clearance-calc';
const chartDatasUri = '/api/chartdata';

const startingVehicles = {
   v1: { group: 1, type: 0 },
   v2: { group: 1, type: 4 },
};

$(function () {
   try {
      v = new VehicleManager(catName);
      v2 = new VehicleManager(catName);

      initHandlers();
      updateFreightMode(); // set initial freight state (radio buttons)
      loadPage(); // get the vehicles database and refresh the page.
      const speedLimit = Number($('#selKPH').val());
      charts.buildAccelerationChart('driveSimChart', speedLimit); // initialise the chart with default data
   } catch (error) {
      console.log(error.message);
      window.location.href =
         '/error?message=' + encodeURIComponent('An unexpected error occurred on starting the intersection tool.');
   }
});

function initHandlers() {
   // median change
   $('#chkMedian').on('change', toggleMedian);

   // speed limit change
   $('#selKPH').on('change', function () {
      //console.log('speed limit: ' + this.value);
      charts.updateSpeedLimit(Number(this.value));
   });

   // freight task change, buttons
   $('input[name="btnradio"]').on('change', updateFreightMode);

   // freight task change, vales
   $('.freightInput').on('change', updateFreightResult);

   // handle form changes
   $('#intersectionForm input, #intersectionForm select').on('change', function () {
      updateIntersection();
      // Further process the formData or call other functions here
   });

   // handle vehicle group changing
   $('.vehicle-group').on('change', function () {
      let id = this.getAttribute('id'); // get the id, e.g., "vehicle-group-1"
      let vehicleNumber = parseInt(id.split('-').pop()); // split by '-' and take the last part, and parse it to an integer
      selectVehicleGroup(vehicleNumber, this.value); // also sets default vehicle group
   });

   $('.vehicle-type').on('change', function () {
      let id = this.getAttribute('id');
      let vehicleNumber = parseInt(id.split('-').pop());
      selectVehicleType(vehicleNumber, this.value);
   });

   // calculate on clicking results tab
   $('#results-tab').on('click', calcClearance);

   // screen print
   $('#printScreen').on('click', function (event) {
      event.preventDefault();
      console.log('Print');
      window.print(); // Trigger the print dialog
   });
}

function loadPage() {
   // starting intersection
   updateIntersection();

   // Populate vehicle types dropdowns
   const groups = v.getVehicleGroups();
   $('.vehicle-group').empty();
   for (let i = 0; i < groups.length; i++) {
      const name = groups[i].name;
      const val = groups[i].index;
      $('#vehicle-group-1').append(new Option(name, val));
      $('#vehicle-group-2').append(new Option(name, val));
   }

   // retrieve available vehicles and then populate page
   const customEntries = [];
   v.initVehicles(customEntries, function () {
      //console.log('v.initVehicles callback');
      selectVehicleDefault(1, startingVehicles.v1.group, startingVehicles.v1.type);
   });
   v2.initVehicles(customEntries, function () {
      //console.log('v2.initVehicles callback');
      selectVehicleDefault(2, startingVehicles.v2.group, startingVehicles.v2.type);
   });
}

function selectVehicleDefault(vehicleNumber, groupIndex, vehicleIndex) {
   // reset the vehicle selectors
   $(`#vehicle-group-${vehicleNumber}`).val(groupIndex);
   selectVehicleGroup(vehicleNumber, groupIndex, vehicleIndex);
}

//
//  Intersection builder
//
function toggleMedian() {
   const $medianInput = $('#inpMedianWidth');
   const $medianLabel = $('label[for="inpMedianWidth"]');
   if ($('#chkMedian').is(':checked')) {
      $medianInput.show();
      $medianLabel.show();
   } else {
      $medianInput.hide();
      $medianLabel.hide();
   }
}

function updateIntersection() {
   // update the intersection diagram with current intersection data.
   var d = getIntersection();

   // show hide median width on form
   $('#divMedian').toggle(d.includeMedian);
   $('#divNoMedian').toggle(!d.includeMedian);

   // show hide carriageways on diagram
   $('.carriageway').hide(); // hide all first
   for (let i = 1; i <= d.farCarriagewayLanes; i++) {
      $(`#far-${i}`).show();
   }
   for (let i = 1; i <= d.nearCarriagewayLanes; i++) {
      $(`#near-${i}`).show();
   }

   // update diagram values based on form
   $('.update-speed').text(d.targetSpeed);
   $('.update-far-width').text(d.farCarriagewayWidth);
   $('.update-medium-width').text(d.medianWidth);
   $('.update-near-width').text(d.nearCarriagewayWidth);
   $('.update-stop-dist').text(d.stopLineDistance);
}

function getIntersection() {
   return {
      targetSpeed: $('#selKPH').val(),
      farCarriagewayWidth: $('#inpFarWidth').val(),
      farCarriagewayLanes: $('#selFar').val(),
      includeMedian: $('#chkMedian').is(':checked'),
      medianWidth: $('#inpMedianWidth').val(),
      nearCarriagewayWidth: $('#inpNearWidth').val(),
      nearCarriagewayLanes: $('#nearLanes').val(),
      stopLineDistance: $('#inpStopLine').val(),
   };
}
//
// Vehicles and types
//

function selectVehicleGroup(vehicleNumber, groupIndex, vehicleIndex = 0) {
   const vmanager = vehicleNumber == 1 ? v : v2;
   $(`#vehicle-group-${vehicleNumber}`).val(groupIndex);
   vmanager.setVehicleGroup(groupIndex);
   const names = vmanager.getActiveGroupVehicleNames();

   $(`#vehicle-type-${vehicleNumber}`).empty();
   for (let i = 0; i < names.length; i++) {
      $(`#vehicle-type-${vehicleNumber}`).append(new Option(names[i], i));
   }

   $(`#vehicle-type-${vehicleNumber}`).val(vehicleIndex);
   selectVehicleType(vehicleNumber, vehicleIndex); //default first entry =0
}

function selectVehicleType(vehicleNumber, vehicleIndex) {
   //console.log('selectVehicleType');
   // Called when user changes vehicle type
   const vmanager = vehicleNumber == 1 ? v : v2;
   vmanager.setActiveVehicle(vehicleIndex);
   const selectedVehicle = vmanager.getActiveVehicle();
   const path = vmanager.getImagePath();

   // vehicle image in right pane and also results tab
   $(`#vehicleImage-${vehicleNumber}`).attr('src', path + selectedVehicle.image);
   $(`#resultsImage-${vehicleNumber}`).attr('src', path + selectedVehicle.image);

   updateVehicleInfo(vehicleNumber, selectedVehicle);
   refreshAccelChart(vehicleNumber, selectedVehicle);
}

function updateVehicleInfo(vehicleNumber, selectedVehicle) {
   // Update vehicle pane info when vehicle is changed.
   $(`#info-vehicle-${vehicleNumber}`).text(`${selectedVehicle.description}`);
   $(`#info-engine-${vehicleNumber}`).text(`${selectedVehicle.engine}`);
   $(`#info-network-${vehicleNumber}`).text(selectedVehicle.approved + ' - ' + selectedVehicle.network);
   $(`#info-mass-${vehicleNumber}`).text(selectedVehicle.gcm + ' t');
   $(`#info-length-${vehicleNumber}`).text(selectedVehicle.length);
}

//
// Acceleration chart
//

function refreshAccelChart(vehicleNumber, selectedVehicle) {
   const profileId = selectedVehicle.profile0;
   if (profileId) {
      // get new acceleration profiles for the vehicles
      $.get(chartDatasUri, { catName: catName, profileId: profileId }, function (d) {
         charts.updateAcceleration(vehicleNumber, d);
      }).fail(function (jqXHR, textStatus, errorThrown) {
         console.log(errorThrown);
      });
   } else {
      console.log('No profiles found for the selected vehicles.');
      return;
   }
}

//
// API Calculations
//

function calcClearance() {
   // called when fields change.

   const vehicleCurrent = getVehicleData(1);
   const vehicleProposed = getVehicleData(2);
   let formData = {
      catName: catName,
      c_vehicle: vehicleCurrent,
      p_vehicle: vehicleProposed,
      intersection: getIntersectionData(),
   };
   $.ajax({
      url: clearanceCalcUri,
      type: 'POST',
      data: formData,
      success: function (d) {
         if (!d.error) {
            latestResults = d.results;
            refreshResults(vehicleCurrent, vehicleProposed, latestResults);
         } else {
            console.error('Invalid results received from clearances api: ' + d.results);
         }
         // update results
      },
      error: function (jqXHR, textStatus, errorThrown) {
         console.error('Error response when calculating clearances');
      },
   });
}

function getVehicleData(vehicleNumber) {
   const vmanager = vehicleNumber == 1 ? v : v2;
   const vehicle = vmanager.getActiveVehicle();

   const data = {
      id: vehicle.id,
      category: vehicle.category,
      description: vehicle.description,
      engine: vehicle.engine,
      approved: vehicle.approved,
      network: vehicle.network,
      length: vehicle.length,
      gcm: vehicle.gcm,
      profile0: vehicle.profile0,
      max_length: vehicle.max_length,
      capacity_mass: vehicle.capacity_mass,
      capacity_vol: vehicle.capacity_vol,
   };
   return data;
}

function getIntersectionData() {
   const intersection = getIntersection();
   const median = intersection.includeMedian ? intersection.medianWidth : 0;
   const data = {
      stopLineDist: intersection.stopLineDistance,
      median: median,
      numLanes: intersection.nearCarriagewayLanes,
      laneWidth: intersection.nearCarriagewayWidth,
      turnRadius: 0.25 * 2 * Math.PI * 7.5, // a 15m turn radius
      targetSpeed: intersection.targetSpeed,
   };
   return data;
}
